const custom = {
    state:{

    },
    mutations:{

    },
    actions:{

    }
}

export default custom
